import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as _ from 'lodash';
import { LoaderEvent } from '../../shared/message.event';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';

@Component({
  selector: 'app-show-log',
  templateUrl: './show-log.component.html',
  styleUrls: ['./show-log.component.css'],
  exportAs: 'showLog'
})
export class ShowLogComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  private failureList = [];
  private successList = [];
  private stringConstants = CONSTANT_MESSAGES;
  private setFlagFor = 1;
  private sentInvitesList = [];
  private noInvitesList = [];
  private confirmBookingList = [];
  private bookingLogList = [];
  @Output() sendInviteFlag = new EventEmitter<boolean>();
  private addedMembers: any = {
    'vendorId': '',
    'members': [],
    'clubName': '',
    isWaitForCallback: true
  };
  constructor(private loaderEvent: LoaderEvent) { }

  ngOnInit() {
  }

  public showChildModal(setFlagFor, failureList, successList, inviteList, confirmBookingList, bookingFailureList, membersToSendInvite): void {
    this.failureList = failureList && failureList.length > 0 ? failureList : [];
    this.successList = successList && successList.length > 0 ? successList : [];
    this.childModal.config.backdrop = false;
    this.childModal.config.keyboard = false;
    this.setFlagFor = setFlagFor;
    this.sentInvitesList = this.setFlagFor == 2 ? inviteList : [];

    if (this.setFlagFor == 2) {
      let list = inviteList;
      this.sentInvitesList = _.uniqBy(this.sentInvitesList, function (e) {
        return e.contactNumber;
      });
      let that = this;
    }
    this.confirmBookingList = confirmBookingList;
    this.bookingLogList = bookingFailureList;
    this.childModal.show();
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  sendInvite(popupObj) {
    this.hideChildModal();
    this.sendInviteFlag.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/member/show-log/show-log.component.ts